<template>
  <div class="block-chip">
    <span class="block-chip__name">{{ label }}</span>
    <div class="block-chip__button" @click.stop="$emit('remove')"></div>
  </div>
</template>

<script>
export default {
  name: 'BaseBlockChip',
  props: {
    label: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
  .block-chip {
    border-radius: 15px;
    background-color: $rfx-light-blue;
    height: 30px;
    margin-right: 16px;
    overflow: hidden;
    color: white;
    box-sizing: border-box;
    width: min-content;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 3px 0 3px 12px;

    &__name {
      font-size: 12px;
      color: #fff;
      text-transform: lowercase;
      width: min-content;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__button {
      position: relative;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      cursor: pointer;
      pointer-events: auto;

      &:before,
      &:after {
        position: absolute;
        right: 12px;
        top: 9px;
        content: " ";
        height: 12px;
        width: 2px;
        background-color: #fff;
      }

      &:before {
        transform: rotate(45deg);
      }

      &:after {
        transform: rotate(-45deg);
      }

      &:hover {
        &:before, &:after {
          background-color: $rfx-silver;
        }
      }
    }
  }
</style>
